/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Explore_Legends_DetailInputs */

const en_common_header_explore_legends_detail = /** @type {(inputs: Common_Header_Explore_Legends_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All-time top launches`)
};

const zh_common_header_explore_legends_detail = /** @type {(inputs: Common_Header_Explore_Legends_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`史上最热发布`)
};

/**
* | output |
* | --- |
* | "All-time top launches" |
*
* @param {Common_Header_Explore_Legends_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_explore_legends_detail = /** @type {((inputs?: Common_Header_Explore_Legends_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Explore_Legends_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_explore_legends_detail(inputs)
	return zh_common_header_explore_legends_detail(inputs)
});
export { common_header_explore_legends_detail as "common.header.explore.legends.detail" }